import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import registrationReducer from './store/reducers/registration';
import menuReducer from './store/reducers/menu';
import planInfoReducer from './store/reducers/planInfo';
import planOutputReducer from './store/reducers/planOutput';
import coverPageReducer from './store/reducers/coverPage';
import globalStateReducer from './store/reducers/globalState';
import adminReducer from './store/reducers/admin';
import productReducer from './store/reducers/productReducer';
import './index.css';
import App from './containers/App/App';
import { unregister } from './registerServiceWorker';

const rootReducer = combineReducers({
    planInfo: planInfoReducer,
    menuState: menuReducer,
    registrationState: registrationReducer,
    planOutputState: planOutputReducer,
    coverPageState: coverPageReducer,
    globalState: globalStateReducer,
    admin: adminReducer,
    productReducer: productReducer
});

const store = createStore(rootReducer, {}, applyMiddleware(thunk));

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
//registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js